module.exports = __webpack_public_path__ + "fonts/402033a.woff";